import { render, staticRenderFns } from "./detallesdepago.vue?vue&type=template&id=78d1a754&scoped=true&"
import script from "./detallesdepago.vue?vue&type=script&lang=js&"
export * from "./detallesdepago.vue?vue&type=script&lang=js&"
import style0 from "./detallesdepago.vue?vue&type=style&index=0&id=78d1a754&lang=scss&scoped=true&"
import style1 from "./detallesdepago.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78d1a754",
  null
  
)

export default component.exports